<script lang="ts" setup>
import apiConfig from "~/shared/config/api";
import customFetch from "~/composables/custom-fetch";
import AppButton from "~/components/ui/buttons/AppButton.vue";
import ResetIcon16 from "~/assets/icons/reset/16/reset.svg?component"
import ResetIcon24 from "~/assets/icons/reset/24/reset.svg?component"
import useWarehousesStore from "~/shared/store/modules/account/warehouses";
import useMainStore from "~/shared/store";
import {useMonitorSize} from "~/composables/monitor-size";
import type {IAccountCityWarehouses} from "~/shared/interfaces/account/sortingWarehouses";
import type {IMonitorSize} from "~/shared/interfaces/composables";

const {account} = apiConfig
const warehousesStore = useWarehousesStore()
const mainStore = useMainStore()
let sizes: IMonitorSize | null = useMonitorSize()

async function clearWarehousesSorting() {
  mainStore.setContentLoadingStatus(false)
  const {data} = await customFetch<{ [slug: string]: IAccountCityWarehouses }>(account.clearWarehousesSorting())

  if (data) {
    warehousesStore.setCityWarehousesList(Object.values(data))
  }

  mainStore.setContentLoadingStatus(true)
}

</script>

<template>
  <div class="clear-sorting">
    <AppButton
      text="Сбросить настройки"
      :icon="ResetIcon16"
      :font-weight="400"
      type="ghost"
      size="s"
      @click="clearWarehousesSorting"
    />
    <AppButton
      :icon="ResetIcon24"
      type="icon"
      size="s"
      sub-type="primary_inverse"
      @click="clearWarehousesSorting"
    />
  </div>
</template>

<style lang="scss" scoped>
.clear-sorting {
  .button {
    &:first-child {
      @include md-breakpoint {
        display: none;
      }
    }

    &:last-child {
      display: none;
      @include md-breakpoint {
        display: flex;
      }
    }
  }
}
</style>
